/**
 * Normalizes an email address for consistent storage and lookup.
 * All email comparisons and writes should go through this function.
 */
export function normalizeEmail(email: string): string {
  return email.toLowerCase().trim();
}
